import { Controller } from "@hotwired/stimulus"

// Swaps the browser-tab title on small screens. The HTML <title> stays the
// desktop value so search results keep a single headline. Matches Tailwind's
// `md` breakpoint (768px): below that, mobile copy is visible.
export default class extends Controller {
  static values = {
    mobile: String,
    desktop: String
  }

  connect() {
    this.media = window.matchMedia("(max-width: 767.98px)")
    this.apply = this.apply.bind(this)
    this.media.addEventListener("change", this.apply)
    this.apply()
  }

  disconnect() {
    this.media?.removeEventListener("change", this.apply)
    if (this.desktopValue) document.title = this.desktopValue
  }

  apply() {
    const mobile = this.media.matches && this.mobileValue
    document.title = mobile ? this.mobileValue : this.desktopValue
  }
}
